import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserSharedWithMe = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7143 13.2857C8.29371 13.2857 6.14657 13.8326 4.73571 14.3083C3.69429 14.6606 3 15.642 3 16.7417V20.1428C3 20.1428 11.5354 20.1428 11.5714 20.1428",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7144 13.2857C8.34785 13.2857 6.42871 10.5094 6.42871 8.14286V7.28571C6.42871 4.91914 8.34785 3 10.7144 3C13.081 3 15.0001 4.91914 15.0001 7.28571V8.14286C15.0001 10.5094 13.081 13.2857 10.7144 13.2857Z",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.7499 16.0023V14.2502C16.7499 14.2016 16.7358 14.154 16.7092 14.1133C16.6826 14.0726 16.6447 14.0405 16.6002 14.021C16.5556 14.0015 16.5063 13.9954 16.4584 14.0035C16.4104 14.0116 16.3659 14.0334 16.3302 14.0665L13.0805 17.0662C13.0551 17.0896 13.0349 17.118 13.021 17.1496C13.0072 17.1813 13 17.2154 13 17.2499C13 17.2844 13.0072 17.3186 13.021 17.3502C13.0349 17.3818 13.0551 17.4102 13.0805 17.4337L16.3302 20.4334C16.3659 20.4664 16.4104 20.4883 16.4584 20.4964C16.5063 20.5044 16.5556 20.4984 16.6002 20.4789C16.6447 20.4594 16.6826 20.4273 16.7092 20.3866C16.7358 20.3459 16.7499 20.2983 16.7499 20.2496V18.5028C19.6674 18.5758 20.1746 19.9319 20.5153 20.8373C20.5358 20.8923 20.5749 20.9383 20.6259 20.9673C20.6769 20.9963 20.7364 21.0064 20.7941 20.996C20.8518 20.9855 20.904 20.9551 20.9415 20.9101C20.9791 20.865 20.9996 20.8082 20.9995 20.7496C20.9995 16.725 18.9887 16.0458 16.7499 16.0023Z",
			fill: "#636C7B"
		})
	]
});
export default SvgUserSharedWithMe;
